const React = require("react");

function DeviceMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
  }));
}

module.exports = DeviceMobileIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/DeviceMobileIcon.js
 ** module id = 504
 ** module chunks = 0
 **/